import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../../services/api';
import Pagination from '@mui/material/Pagination';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';

function OrcamentoSC() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const { id } = useParams();
    const [totalPages, setTotalPages] = useState(0);
    const [itens, setItens] = useState([]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/sc/${id}/orcamento?page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados dos orçamentos da solicitação de compra:", error);
            }
        }
        fetchData();
    }, [page, id]);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`sc/${id}/itens`);
                setItens(response.data);
            } catch (error) {
                console.error("Erro ao buscar dados dos itens:", error);
            }
        }
        fetchData();
    }, [id]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="Orçamentos"
                actionLabel="Adicionar orçamento"
                actionIcon={<AddCircleOutlineIcon />}
                actionTo={`/sc/${id}/orcamento/cadastro`}
            />

            <Paper sx={{ p: 2, mb: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                    Itens da solicitação de compra
                </Typography>
                <Stack spacing={0.5}>
                    {itens.map((item) => (
                        <Typography key={item.id} variant="body2" color="text.secondary">
                            {item.descricao} — {item.quantidade} {item.unidadeMedida}
                        </Typography>
                    ))}
                </Stack>
            </Paper>

            <Grid container spacing={2}>
                {data.map((orcamento) => (
                    <Grid item xs={12} sm={6} md={4} key={orcamento.id}>
                        <Card>
                            <CardActionArea component={Link} to={`/sc/${id}/orcamento/${orcamento.id}`}>
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {orcamento.fornecedor.nome}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {orcamento.prazoEntrega === 0
                                            ? 'Prazo: Imediato'
                                            : orcamento.prazoEntrega === 1
                                                ? 'Prazo: 1 Dia'
                                                : `Prazo: ${orcamento.prazoEntrega} Dias`}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Valor: R$ {orcamento.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default OrcamentoSC;
